import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  initEntry({ commit }) {
    commit(types.INIT_ENTRY)
  },
  setEntry({ commit }, data) {
    commit(types.SET_ENTRY, data)
  },
  updateEntry({ commit }, data) {
    commit(types.UPDATE_ENTRY, data)
  },
  async getEntries({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getEntries', () =>
      http.get('log/entries', {
        params: searchOptions
      })
    )
    commit(types.SET_ENTRIES, r.data)
    return r.data
  },
  async getEntry({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getEntry', () =>
      http.get('log/entry', {
        params: { id }
      })
    )
    commit(types.SET_ENTRY, r.data)
    return r.data
  },
  async saveEntry({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveEntry', () =>
      http.post('log/saveEntry', data)
    )
    return r.data
  },
  async saveUsage({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveUsage', () =>
      http.post('data/saveUsage', data)
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/logging/actions.js